module.exports = __webpack_public_path__ + "static/media/ehealth_minor_reg_banner_mobile.44e1d8a5.jpg";